// Tabs Frontend Script
import './view.scss';

function initTabs() {
	// Find all tabs blocks
	const tabsBlocks = document.querySelectorAll('.wp-block-tabs');

	if (!tabsBlocks.length) {
		return;
	}

	tabsBlocks.forEach((tabsBlock) => {
		// Check if already initialized
		if (tabsBlock.dataset.initialized === 'true') {
			return;
		}

		// Mark as initialized
		tabsBlock.dataset.initialized = 'true';

		const navItems = tabsBlock.querySelectorAll('.wp-block-tabs__nav-item');
		const tabItems = tabsBlock.querySelectorAll('.wp-block-guiding-light-tab-item');
		const indicator = tabsBlock.querySelector('.wp-block-tabs__nav-indicator');

		if (!navItems.length || !tabItems.length) {
			return;
		}

		// Function to update indicator position and width
		const updateIndicator = (activeItem, animate = true) => {
			if (!indicator || !activeItem) return;

			const { offsetLeft, offsetWidth } = activeItem;

			if (!animate) {
				// Set immediately without transition
				indicator.style.transition = 'none';
			}

			requestAnimationFrame(() => {
				indicator.style.width = `${offsetWidth}px`;
				indicator.style.transform = `translateX(${offsetLeft}px)`;

				if (!animate) {
					// Re-enable transition after immediate update
					requestAnimationFrame(() => {
						indicator.style.transition = '';
					});
				}
			});
		};

		// Handle tab click
		navItems.forEach((navItem, index) => {
			navItem.addEventListener('click', () => {
				// Remove active class from all nav items
				navItems.forEach(item => {
					item.classList.remove('is-active');
					item.setAttribute('aria-selected', 'false');
				});

				// Remove active class from all tab items
				tabItems.forEach(item => {
					item.classList.remove('is-active');
					item.setAttribute('aria-hidden', 'true');
				});

				// Add active class to clicked nav item
				navItem.classList.add('is-active');
				navItem.setAttribute('aria-selected', 'true');

				// Add active class to corresponding tab item
				if (tabItems[index]) {
					tabItems[index].classList.add('is-active');
					tabItems[index].setAttribute('aria-hidden', 'false');
				}

				// Update indicator position with animation
				updateIndicator(navItem, true);

				// Dispatch custom event for other scripts to react to tab changes
				const tabChangeEvent = new CustomEvent('tabChange', {
					detail: {
						tabsBlock,
						activeNavItem: navItem,
						activeTabItem: tabItems[index],
						index,
					},
					bubbles: true,
				});
				tabsBlock.dispatchEvent(tabChangeEvent);
			});
		});

		// Initialize first tab as active
		if (navItems[0] && tabItems[0]) {
			navItems[0].classList.add('is-active');
			navItems[0].setAttribute('aria-selected', 'true');
			tabItems[0].classList.add('is-active');
			tabItems[0].setAttribute('aria-hidden', 'false');

			// Set initial indicator position without animation
			updateIndicator(navItems[0], false);
		}

		// Handle window resize - recalculate indicator position
		let resizeTimeout;
		const handleResize = () => {
			clearTimeout(resizeTimeout);
			resizeTimeout = setTimeout(() => {
				const activeItem = tabsBlock.querySelector('.wp-block-tabs__nav-item.is-active');
				if (activeItem) {
					updateIndicator(activeItem, false);
				}
			}, 150);
		};

		window.addEventListener('resize', handleResize);

		// Store cleanup function for potential future use
		tabsBlock._cleanup = () => {
			window.removeEventListener('resize', handleResize);
			clearTimeout(resizeTimeout);
		};
	});
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', initTabs);
} else {
	initTabs();
}
